export default {
    title:'',
    endP:'This promotion has ended',
    versionLowPlaceholder:"Redirection needs to be updated to the latest version. Please check it in the App.",
    versionPlaceholder:"This app version is too old and cannot join this campaign. Please go to 【Setting】> 【Version】 to upgrade.",
    common:{
        errorText:"Unknown error, please try again later;",
        errorMiss:"Parameter is missing;",
        submit: "Submit",
        defaultInput: "please input",
        cancel: "Cancel",
        confirm: "Confirm",
        loginTimeout: "Havne't logged in or session timeout, please login again",
        noData: "No Data",
        custom: "Live Chat Support",
    },
    route: {
        dashboard: 'Dashboard',
        introduction: 'Introduction',
        documentation: 'Documentation',
        permission: 'Permission',
        icons: 'Icons',
        components: 'Components',
        componentIndex: 'Introduction',
        tinymce: 'Tinymce',
        markdown: 'Markdown',
        jsonEditor: 'JSON Editor',
        dndList: 'Dnd List',
        splitPane: 'SplitPane',
        avatarUpload: 'Avatar Upload',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: 'Mixin',
        backToTop: 'BackToTop',
        charts: 'Charts',
        keyboardChart: 'Keyboard Chart',
        lineChart: 'Line Chart',
        mixChart: 'Mix Chart',
        example: 'Example',
        Table: 'Table',
        dynamicTable: 'Dynamic Table',
        dragTable: 'Drag Table',
        inlineEditTable: 'Inline Edit',
        complexTable: 'Complex Table',
        treeTable: 'Tree Table',
        customTreeTable: 'Custom TreeTable',
        tab: 'Tab',
        form: 'Form',
        createForm: 'Create Form',
        editForm: 'Edit Form',
        errorPages: 'Error Pages',
        page401: '401',
        page404: '404',
        errorLog: 'Error Log',
        excel: 'Excel',
        exportExcel: 'Export Excel',
        selectExcel: 'Export Selected',
        uploadExcel: 'Upload Excel',
        zip: 'Zip',
        exportZip: 'Export Zip',
        theme: 'Theme',
        clipboardDemo: 'Clipboard',
        i18n: 'I18n'
    },
    navbar: {
        logOut: 'Log Out',
        dashboard: 'Dashboard',
        github: 'Github',
        screenfull: 'screenfull',
        theme: 'theme'
    },
    login: {
        title: 'Login Form',
        logIn: 'Log in',
        username: 'Username',
        password: 'Password',
        any: 'any',
        thirdparty: 'Or connect with',
        thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
    },
    documentation: {
        documentation: 'Documentation',
        github: 'Github Repository'
    },
    permission: {
        roles: 'Your roles',
        switchRoles: 'Switch roles'
    },
    components: {
        documentation: 'Documentation',
        tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
        dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
        stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
        backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
        backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
        imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
    },
    table: {
        dynamicTips1: 'Fixed header, sorted by header order',
        dynamicTips2: 'Not fixed header, sorted by click order',
        dragTips1: 'The default order',
        dragTips2: 'The after dragging order',
        title: 'Title',
        importance: 'Imp',
        type: 'Type',
        remark: 'Remark',
        search: 'Search',
        add: 'Add',
        export: 'Export',
        reviewer: 'reviewer',
        id: 'ID',
        date: 'Date',
        author: 'Author',
        readings: 'Readings',
        status: 'Status',
        actions: 'Actions',
        edit: 'Edit',
        publish: 'Publish',
        draft: 'Draft',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm'
    },
    errorLog: {
        tips: 'Please click the bug icon in the upper right corner',
        description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
        documentation: 'Document introduction'
    },
    excel: {
        export: 'Export',
        selectedExport: 'Export selected items',
        placeholder: 'Please enter the file name(default excel-list)'
    },
    zip: {
        export: 'Export',
        placeholder: 'Please enter the file name(default file)'
    },
    theme: {
        change: 'Theme change',
        documentation: 'Theme documentation',
        tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
    },
    "veritrans": {
        "orderNo": "Order Number",
        "cardNum": "Card Number",
        "cardholderName": "Cardholder name",
        "inputCard": "Please enter your card number",
        "inputCardholderName": "Please enter Cardholder name",
        "supportType": "Support type",
        "expiryDate": "Expire Date",
        "csc": "CSC",
        "pay": "Pay",
        "paySettle": "Payment processing",
        "payCancel": "Payment cancelled",
        "payFailed": "Failure to pay",
        "succeed": "Payment Completed",
        "fail": "Payment failed, please order again",
        "Cancelpay": "Cancel payment",
        "repay": "Re payment",
        "contactUs": "Contact customer service"
    },
    "msgPush": {
        "tips": "Turn off {name} notifications?",
        "closePush": "If you turn off notifications, you may miss our exclusive deals!",
        "confirm": "Turn off",
        "cancel": "Cancel",
        "appPush": "Push",
        "emailPush": "Email",
        "loginFirst": "Not logged in or login disabled if you need to continue?"
    },
    //paygo---开始
    "title":"GlocalMe",
    "route.Home": "PAYG",
    "route.rate":"Global Rates",
    "route.record":"Payment History",
    "common.nonedata": "No Data",
    "common.nonedataRate" : "No Rate",
    "common.more" : "More",
    "route.home.flowType" : "Pay-As-You-Go",
    "route.home.rateTit" : "Rate",
    "route.home.timeUse" : "Time",
    "route.home.DataUse" : "Data",
    "route.home.MoneyUse" : "Payment",
    "route.home.history" : "Payment Histroy >",
    "route.home.OtherRate" : "All Rates",
    "route.home.useMethod" : "Methods",
    "route.home.addMinutes" : "Top-up in advance",
    "route.home.arrived" : "Turn on the device after arriving",
    "route.home.useRule" : "Terms and Conditions",
    "route.home.updateTips" : "You have not upgrade to Easy GO service",
    "route.home.updateBtn" : "Upgrade",
    "route.home.updateBtn2" : "Upgrade Now",
    "route.home.LaterUpdateBtn" : "Later",
    "route.home.updateService" : "Upgrade Service",
    "route.home.updateSuccess" : "Upgrade Successful",
    "route.home.country" : "Couontry",///Region
    "route.home.cost" : "Rate",
    "route.home.TopCost" : "Capping",
    "route.home.Success" : "Ok",
    "route.home.where" : "Unreachable location",
    "route.home.ReLogin":"Upgrade successful. The data packages in your account have been switched to data add-ons. Please relogin for the changes to take effect. And please make sure your account has sufficient funds to cover the trip.",
    "route.home.ReLoginBtn":"ReLogin",
    "route.home.flowTypeDesc":"Enable Pay-As-You-Go function to keep using our data service when there is no valid data package,an amount of your account balance will be temporally frozen to pay the data usage.(Rate:{rateCurrency} {rate}/MB)",
    "route.home.flowTypeDescLimit":"Enable Pay-As-You-Go function to keep using our data service when there is no valid data package,an amount of your account balance will be temporally frozen to pay the data usage.(Rate:{rateCurrency} {rate}/MB,Charge cap:{amountCurrency} {amount})",
    errorCode: {
        '01282001': 'Account or password error',//登录用户名或密码错误
        '01282002': 'Account is deactivated',//登录用户已停用
        '01282003': 'Account is empty',//登录用户名为空
        '01282004': 'Password is empty',//登录密码为空
        '01282501': 'Partner is not exist',//代理商不存在
        '01282503': 'Partner status is invalid'//代理商已停用
    },
    "paygo.basePayFlagMsg.true":"Open Success",
    "paygo.basePayFlagMsg.false":"OFF Success",
    "paygo.QueryFlowHistory.NullData":"No data",
    //paygo---结束
}



// WEBPACK FOOTER //
// ./src/lang/en.js